import { get, put, del } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';

const apiName = "api-maitrise";
const baseUrl = "/maitrise";

const getAuthHeaders = async () => {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();
    return idToken ? { Authorization: `Bearer ${idToken}` } : {};
};

export function getNotifications(callBack) {
    (async () => {
        const restOperation = get({
            apiName,
            path: `${baseUrl}/notifications`,
            options: { cache: 'no-store', headers: await getAuthHeaders() }
        });

        restOperation.response
            .then(async ({ body }) => {
                const result = await body.json();
                callBack(result?.notifications ?? []);
            })
            .catch(err => {
                console.log(err.message);
                callBack([]);
            });
    })().catch(err => {
        console.log(err.message);
        callBack([]);
    });
}

export function markNotificationsRead({ all = false, notificationIds = [] } = {}, callBack) {
    (async () => {
        const restOperation = put({
            apiName,
            path: `${baseUrl}/notifications/read`,
            options: {
                headers: await getAuthHeaders(),
                body: { all, notificationIds }
            }
        });

        restOperation.response
            .then(async ({ body }) => {
                const result = await body.json();
                if (callBack) {
                    callBack(null, result);
                }
            })
            .catch(err => {
                console.log(err.message);
                if (callBack) {
                    callBack(err);
                }
            });
    })().catch(err => {
        console.log(err.message);
        if (callBack) {
            callBack(err);
        }
    });
}

export function deleteNotifications({ allRead = false, notificationIds = [] } = {}, callBack) {
    (async () => {
        const restOperation = del({
            apiName,
            path: `${baseUrl}/notifications`,
            options: {
                headers: await getAuthHeaders(),
                body: { allRead, notificationIds }
            }
        });

        await restOperation.response;
        if (callBack) {
            callBack(null);
        }
    })().catch(err => {
        console.log(err.message);
        if (callBack) {
            callBack(err);
        }
    });
}
